import Alert from '@mui/material/Alert';
import React, {  } from 'react';
import __t from "../../../lib/traduzioni";


const NumPrezziProposti = ({npreventivi, ndatiFiltrati, coniuglabelfiltro, coniuglabel}) => {

    return (
        <>
            {(npreventivi !== ndatiFiltrati) ? 
                ndatiFiltrati > 0 ? (
                    <>
                        <b>{ndatiFiltrati}</b> {__t("propost")}{__t(coniuglabelfiltro)} {__t("filtrat")}{__t(coniuglabelfiltro)}
                    </>
                ) : (
                    <>
                        <Alert severity="warning">                                                           
                            {__t("nopreventiviperfiltri")}
                        </Alert>
                    </>
                )
                
            : (
                <>
                    <b>{npreventivi}</b> {__t("propost")}{__t(coniuglabel)} {__t("trovat")}{__t(coniuglabel)}
                </>
            )}
        </>
    )
}

export default NumPrezziProposti;